// Хелпер для форматирования даты

export default (date) => {
  const dateOptions = {
    month: 'short',
    day: 'numeric'
  };

  return new Date(date).toLocaleString('default', dateOptions);
};
